import React, { Component } from "react"

function addMeta(data) {
  data[$("meta[name=csrf-param]").attr("content")] = $("meta[name=csrf-token]").attr("content")
  return data
}

export default class Enable extends Component {
  changeValue(enabled) {
    $(".questionnaire-administration")[enabled ? "removeClass" : "addClass"]("hidden")

    const url = `/super/organizations/${this.props.organization_id}/questionnaires/enable`
    $.ajax({
      url: url,
      type: "post",
      data: addMeta({enable: enabled ? 1 : 0})
    })
  }

  renderChoices() {
    return <select defaultValue={this.props.enabled ? "1" : "0"} onChange={e => this.changeValue(parseInt(e.target.value) == 1)}>
      <option value="1">Yes</option>
      <option value="0">No</option>
    </select>
  }

  render() {
    return <div className="row">
      <div className="col-sm-4">Questionnaires Enabled?</div>
      <div className="col-sm-4">
        {this.renderChoices()}
      </div>
    </div>
  }
};